export default __webpack_public_path__ + "static/media/Payment-not.0f9968f7.svg";